module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_c('div', [_vm._v("活动商品信息")])]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动封面"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgChange
    }
  }, [(_vm.form.banner_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.banner_img
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name",
      "rules": {
        required: true,
        message: '活动名称必填',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.form.activity_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_name", $$v)
      },
      expression: "form.activity_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "取货时间",
      "prop": "delivery_date"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.delivery_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery_date", $$v)
      },
      expression: "form.delivery_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动描述"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "社区限制"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.communityChange
    },
    model: {
      value: (_vm.community),
      callback: function($$v) {
        _vm.community = $$v
      },
      expression: "community"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("不限制社区")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("指定社区")])], 1), _vm._v(" "), (_vm.community == 2) ? _c('div', {
    staticStyle: {
      "margin-left": "1.5%"
    }
  }, [
    [_c('el-table', {
      ref: "multipleTable",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.communityList,
        "tooltip-effect": "dark",
        "row-key": _vm.getCommunityRowKeys
      },
      on: {
        "selection-change": _vm.handleCommunitySelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "reserve-selection": true,
        "width": "55"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "社区名称"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.community_name))]
        }
      }], null, false, 3192370358)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "leader_name",
        "label": "团长姓名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "leader_mobile",
        "label": "团长手机",
        "min-width": "110"
      }
    })], 1), _vm._v(" "), (_vm.communitycount > _vm.communityParams.pageSize) ? _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "current-page": _vm.communityParams.page,
        "total": _vm.communitycount,
        "page-size": _vm.communityParams.pageSize
      },
      on: {
        "current-change": _vm.handleCommunityChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.communityParams, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.communityParams, "page", $event)
        }
      }
    })], 1) : _vm._e()]
  ], 2) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.form.status == 'processing') ? _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "当前活动正在进行中，只能新增商品，或者修改已有商品库存",
      "type": "warning"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "绑定商品"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-button', {
    staticClass: "el-icon-plus",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.relItems
    }
  }, [_vm._v("选择商品")]), _vm._v(" "), (_vm.form.items.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动价",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "min": "0.01",
            "size": "mini"
          },
          model: {
            value: (scope.row.activity_price),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_price", $$v)
            },
            expression: "scope.row.activity_price"
          }
        }, [_c('i', {
          staticClass: "el-input__icon",
          attrs: {
            "slot": "prefix"
          },
          slot: "prefix"
        }, [_vm._v(_vm._s(_vm.cursymbol))])])]
      }
    }], null, false, 276611145)
  }), _vm._v(" "), (_vm.vipGrade.length == 1) ? _c('el-table-column', {
    attrs: {
      "label": "付费会员价",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.vipGrade[0].lv_type == 'vip') ? _c('div', [_c('el-input', {
          staticClass: "member-price",
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.vip_price),
            callback: function($$v) {
              _vm.$set(scope.row, "vip_price", $$v)
            },
            expression: "scope.row.vip_price"
          }
        }, [_c('i', {
          staticClass: "el-input__icon",
          attrs: {
            "slot": "prefix"
          },
          slot: "prefix"
        }, [_vm._v("vip:" + _vm._s(_vm.cursymbol))])])], 1) : _vm._e(), _vm._v(" "), (_vm.vipGrade[0].lv_type == 'svip') ? _c('div', [_c('el-input', {
          staticClass: "member-price",
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.svip_price),
            callback: function($$v) {
              _vm.$set(scope.row, "svip_price", $$v)
            },
            expression: "scope.row.svip_price"
          }
        }, [_c('i', {
          staticClass: "el-input__icon",
          attrs: {
            "slot": "prefix"
          },
          slot: "prefix"
        }, [_vm._v("svip:" + _vm._s(_vm.cursymbol))])])], 1) : _vm._e()]
      }
    }], null, false, 2346021347)
  }) : _vm._e(), _vm._v(" "), (_vm.vipGrade.length == 2) ? _c('el-table-column', {
    attrs: {
      "label": "付费会员价",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "member-price",
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.vip_price),
            callback: function($$v) {
              _vm.$set(scope.row, "vip_price", $$v)
            },
            expression: "scope.row.vip_price"
          }
        }, [_c('i', {
          staticClass: "el-input__icon",
          attrs: {
            "slot": "prefix"
          },
          slot: "prefix"
        }, [_vm._v("vip:" + _vm._s(_vm.cursymbol))])]), _vm._v(" "), _c('el-input', {
          staticClass: "member-price",
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.svip_price),
            callback: function($$v) {
              _vm.$set(scope.row, "svip_price", $$v)
            },
            expression: "scope.row.svip_price"
          }
        }, [_c('i', {
          staticClass: "el-input__icon",
          attrs: {
            "slot": "prefix"
          },
          slot: "prefix"
        }, [_vm._v("svip:" + _vm._s(_vm.cursymbol))])])]
      }
    }], null, false, 1517531216)
  }) : _vm._e(), _vm._v(" "), (_vm.vipGrade.length == 0) ? _c('el-table-column', {
    attrs: {
      "label": "付费会员价",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  无付费会员等级，不需要设置价格\n                ")]
      }
    }], null, false, 3260338022)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    已售：" + _vm._s(scope.row.sales_store) + "\n                    "), _c('el-input', {
          attrs: {
            "size": "mini",
            "width": "50"
          },
          model: {
            value: (scope.row.activity_store),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_store", $$v)
            },
            expression: "scope.row.activity_store"
          }
        })]
      }
    }], null, false, 645961082)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "每人限购",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.limit_num),
            callback: function($$v) {
              _vm.$set(scope.row, "limit_num", $$v)
            },
            expression: "scope.row.limit_num"
          }
        })]
      }
    }], null, false, 3741221881)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "初始销量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.initial_sales),
            callback: function($$v) {
              _vm.$set(scope.row, "initial_sales", $$v)
            },
            expression: "scope.row.initial_sales"
          }
        })]
      }
    }], null, false, 616798476)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "积分",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.points),
            callback: function($$v) {
              _vm.$set(scope.row, "points", $$v)
            },
            expression: "scope.row.points"
          }
        })]
      }
    }], null, false, 1047712474)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.sort),
            callback: function($$v) {
              _vm.$set(scope.row, "sort", $$v)
            },
            expression: "scope.row.sort"
          }
        })]
      }
    }], null, false, 243219967)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteItemRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 1914607797)
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitActivityAction
    }
  }, [_vm._v("保存")])], 1)], 1)]), _vm._v(" "), _c('GoodsSelect', {
    attrs: {
      "items-visible": _vm.itemVisible,
      "get-status": _vm.setItemStatus,
      "rel-items-ids": _vm.relItemsIds,
      "not-sku": ""
    },
    on: {
      "chooseStore": _vm.chooseItemsAction,
      "closeStoreDialog": _vm.closeItemDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4aec0dc4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aec0dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/activity/add.vue
// module id = 2688
// module chunks = 0